import { render, staticRenderFns } from "./DimensionFilterSelect.vue?vue&type=template&id=961822dc&scoped=true"
import script from "./DimensionFilterSelect.vue?vue&type=script&lang=js"
export * from "./DimensionFilterSelect.vue?vue&type=script&lang=js"
import style0 from "./DimensionFilterSelect.vue?vue&type=style&index=0&id=961822dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961822dc",
  null
  
)

export default component.exports